import React, { useEffect, useState, useRef } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
import "./BybBanner.css";
import "../../../Responsive.css";
import "../../../Tab.css";
import { Helmet } from "react-helmet";
// import { createPopup } from '@typeform/embed'; // Ensure proper import

// import header_pic from "/src/assets/images/header_pic.svg";
// import video from "https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/header_video.webm";
// import "animate.css";

function BybBanner() {

// const [systemInfo, setSystemInfo] = useState({
//     platform: "",
//     userAgent: "",
//     cpuCores: 0,
//   });

//   useEffect(() => {
//     const fetchSystemInfo = () => {
//       const platform = navigator.platform || 'Unknown';
//       const userAgent = navigator.userAgent || 'Unknown';
//       const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
//       setSystemInfo({ platform, userAgent, cpuCores });
//     };

//     fetchSystemInfo();
//   }, []);

  

//   useEffect(() => {
//     const detectMacArchitecture = () => {
//      const check_list =   document.body.querySelector('.check_list');
//      const bybAnalysis =   document.body.querySelector('.byb-analysis');
//      const bybAudit =   document.body.querySelector('.byb-audit');
//      const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
//     //  const legacy =   document.body.querySelector(' .legacy-content');

    
//       const body = document.body;
      
//       const { platform, cpuCores } = systemInfo;

//       if (platform.includes('Win')) {
//         // legacy.style.backgroundColor ="brown"
//         body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
//         check_list.style.background ="rgb(7 26 40)"
//         bybAnalysis.style.background ="rgb(7 26 40)"
//         bybAudit.style.background="rgb(7 26 40)"
//         check_list_believe.style.background="rgb(7 26 40)"
//         // legacy.style.background="rgb(7 26 40)"
        
//         // check_list_believe
//       }
//        else if (platform.includes('Mac'))
//          {  
//         if (cpuCores >= 8) {
//           body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
//           check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
//           bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
//           bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
//           // legacy.style.background="hwb(202.33deg 0.78% 82.35%)"

//         } else {
//           body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
//           check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
//           bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
//           bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
//           // legacy.style.background="hwb(204.29deg 1.18% 82.35%)"

//         }
//       } 
   
//     };

//     detectMacArchitecture();
//   }, [systemInfo]); // Added systemInfo as a dependency to useEffect

  const [isVisible, setIsVisible] = useState(true);

    const panelsRef = useRef([]);
  
  const textRef = useRef(null);
  
  return (
    <>


      <Helmet>
          {/* <title>Brew Your Brand | Branding Tools & Creative Community</title> */}
          {/* <meta name="description" content="Brew Your Brand is your go-to space for brand clarity, creative collaboration, and strategy - plus tools, resources, and a community to grow with." /> */}
      </Helmet>

      <section className="banner-byb new_byb">
        <div className="container">
          

        <div className="description panel byb-toolkit"  id="header_text">
        <div className="legacy-content " style={{backgroundColor:"transparent"}}>
   
        <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}>Brew Your Brand</p>
            <h1>
              <span className="d-inline d-lg-block ">
                 A Dynamic Community of</span> 
                  <span className="d-inline d-lg-block "> Strategists, Designers, Marketers, and Entrepreneurs</span>  Shaping Tomorrow’s Brands. 
            </h1>
            
        </div>
     
      </div>
        </div>
        <div className="byb-toolkit-img ">
              <img
                className="vision-image desk_header_img"
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/header_pic.svg"
                alt="Brew Your Brand community and toolkit hero visual"
                style={{ height: "auto", objectFit: "cover" }}
              />
                <img
                className="vision-image mob_header_img"
                src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/banner_mobile.svg"
                alt="Brew Your Brand mobile hero visual" style={{ height: "auto", objectFit: "cover" }}
              />

            </div>
      </section>
    </>
  );
}

export default BybBanner;
